module.exports = __webpack_public_path__ + "static/img/e_bcg.559c9437.png";